<template>
  <div
    class="modal-overlay"
    :class="{ blurred: isBlurred }"
    ref="refRoot"
    tabindex="0"
    @mousedown="onMouseDown"
    @mouseup="onMouseUp"
  >
    <div class="modal-content" :class="{ 'move-up': moveUp }">
      <header>
        <h3>{{ title }}</h3>
        <!--모달 타이틀-->
        <div class="close-icon">
          <CloseIcon @click="closeModal" />
        </div>
      </header>
      <main>
        <slot></slot>
        <!--모달 내용-->
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';

import CloseIcon from '@/components/icons/IconClose.vue';
import { useKeyPress } from '@/composables/shared/useKeyPress';

const props = withDefaults(
  defineProps<{
    title: string;
    isBlurred?: boolean;
    moveUp?: boolean;
  }>(),
  {
    title: '',
    isBlurred: true,
    moveUp: true,
  }
);
const emit = defineEmits(['close']);

const refRoot = ref<HTMLElement | null>(null);
let mouseDownTarget: EventTarget | null = null;

const onMouseDown = (e: MouseEvent) => {
  mouseDownTarget = e.target;
};

const onMouseUp = (e: MouseEvent) => {
  if (e.target === e.currentTarget && mouseDownTarget === e.currentTarget) {
    closeModal();
  }
};

const closeModal = () => {
  emit('close');
};

useKeyPress(refRoot, {
  Escape: () => {
    closeModal();
  },
});

onMounted(() => {
  refRoot.value?.focus();
  document.body.style.overflow = 'hidden';
});

onUnmounted(() => {
  document.body.style.overflow = '';
});
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1500;
}

.modal-overlay.blurred {
  background: var(--surface-glass-dark);
  backdrop-filter: $blur-medium;
}

.modal-content {
  width: 20rem;
  height: fit-content;
  max-height: 90dvh;
  border-radius: 8px;
  background: var(--surface-default);
  box-shadow: $shadow-modal;
}

main {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.75rem 1.25rem 1.25rem 1.25rem;
  overflow-y: auto;
  max-height: calc(90dvh - 4rem);
  overflow-x: hidden;
}

header {
  display: flex;
  justify-content: space-between;
  padding: 1rem 1rem 0 1.25rem;
}

.close-icon {
  display: flex;
  cursor: pointer;
  width: 1.5rem;
  height: 1.5rem;
}

@media (min-width: 768px) {
  .modal-content {
    width: 40rem;
  }
}

.move-up {
  transition: transform 0.3s ease-in-out;
}
</style>
